var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSms(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sms_svg__clip0_5627_107164)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.38 9.869L19.977 7.082c-1.794-.481-3.595.512-4.02 2.216L10.722 30.29c-.425 1.705.687 3.478 2.481 3.959l10.402 2.787c1.795.48 3.596-.512 4.02-2.216l5.236-20.994c.424-1.704-.687-3.477-2.481-3.958zM19.136 32.71c-1.08-.29-1.745-1.35-1.489-2.375s1.333-1.62 2.412-1.33c1.08.289 1.744 1.35 1.489 2.375-.256 1.025-1.333 1.619-2.412 1.33z",
    fill: "#85A5FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "sms_svg__clip0_5627_107164"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "matrix(.96593 .25882 -.24194 .9703 9 0)",
    d: "M0 0h36v36H0z"
  })))));
}

export default __webpack_public_path__ + "./fonts/sms.4634908448c830cd001548cd2fabd110.svg";
export { SvgSms as ReactComponent };